import {MovieLayer} from 'common/src/modules/movie/movieLayers.types';
import applyKeyframe from 'common/src/modules/movie/utils/applyKeyframe';
import layerTransformToDOMMatrix from 'common/src/modules/movieEditor/utils/layerTranformToDOMMatrix';
import {MovieComp} from 'common/src/modules/movie/movie.types';

function getLayerTotalTransform(
  comp: MovieComp,
  layer: MovieLayer,
  currentTime: number,
): DOMMatrix {
  if (!layer || !comp?.l) return null;

  let curLayer: MovieLayer = layer;
  let matrix = layerTransformToDOMMatrix(applyKeyframe(layer.tr, currentTime));

  while (curLayer.pi) {
    curLayer = comp.l.find((l) => +l.i === +curLayer.pi);
    const transformMatrix = layerTransformToDOMMatrix(applyKeyframe(curLayer.tr, currentTime));
    matrix = transformMatrix.multiply(matrix);
  }

  return matrix;
}

export default getLayerTotalTransform;
